// extracted by mini-css-extract-plugin
export default {"list":"ClipboardList_list__AzUMT","panel":"ClipboardList_panel__RvhF+","disabled":"ClipboardList_disabled__vbNNn"};